import React from "react";
import { FormControl, InputLabel, Select, MenuItem, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: 25,
    borderBottom: '1px solid white',
  },
  icon: {
    fill: '#FAFAFA',
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: "#FAFAFA",
  },
  cssLabel: {
    color: '#FAFAFA',//required color
  },
}));

export const SelectTipoEfector = ({options, handleChange, value}) => {
  const classes = useStyles();

  return (
    <FormControl
      classes={{ root: classes.root }}
      margin="normal"
      fullWidth={true}
    >
      <InputLabel className={classes.cssLabel}>SubTipo de Efector</InputLabel>
      <Select
        onChange={handleChange}
        value={value}
        inputProps={{
          classes: {
            root: classes.border,
            icon: classes.icon,
          },
        }}
      >
        {options.map((t) => (
          <MenuItem key={t.idSubTipoEfector} value={t.idSubTipoEfector}>
            {t.descripcionSubTipoEfector}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
